import { z } from "zod";
import { optionalEnum } from "./_helpers/optional";
import { ExternalIdEntrySchema } from "./external-id.schema";

const channelTypes = ["direct", "retail_partner", "wholesale"] as const;

export const BrandSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  name: z.string().describe("Name"),
  short_code: z.string().nullable().describe("Short Code"),
  channel_type: z.enum(channelTypes).nullable().describe("Channel Type"),
  partner_name: z.string().nullable().describe("Partner Name"),
  logo_url: z.string().nullable().describe("Logo URL"),
  icon_url: z.string().nullable().describe("Icon URL"),
  primary_color: z.string().nullable().describe("Primary Color"),
  secondary_color: z.string().nullable().describe("Secondary Color"),
  branding_config: z.record(z.unknown()).describe("Branding Config"),
  is_active: z.boolean().describe("Active"),
  is_default: z.boolean().describe("Default"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
  external_ids: ExternalIdEntrySchema.array()
    .optional()
    .describe("External IDs"),
});
export type Brand = z.infer<typeof BrandSchema>;

export const BrandInsertSchema = z.object({
  business_id: z.string().uuid().describe("Business"),
  name: z.string().describe("Name"),
  short_code: z.string().optional().describe("Short Code"),
  channel_type: optionalEnum(channelTypes).describe("Channel Type"),
  partner_name: z.string().optional().describe("Partner Name"),
  logo_url: z.string().optional().describe("Logo URL"),
  icon_url: z.string().optional().describe("Icon URL"),
  primary_color: z.string().optional().describe("Primary Color"),
  secondary_color: z.string().optional().describe("Secondary Color"),
  branding_config: z.record(z.unknown()).optional().describe("Branding Config"),
  is_active: z.boolean().default(true).describe("Active"),
  is_default: z.boolean().default(false).describe("Default"),
});

export const BrandUpdateSchema = BrandInsertSchema.partial();

export { channelTypes };
